import React from 'react';
import { CoreContainer } from '@hub/core-container';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import { H3 } from '@hub/heading';
import { Link } from '@hub/link';
import { Box } from '@hub/box';
import { Frame } from '@hub/frame';
import useMobileBreakpoint from '@scentregroup/shared/helpers/use-mobile-breakpoint';
import { InlineDeckReel } from './inline-deck-reel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InlineDeck({
  header,
  items,
  as
}) {
  const isMobile = useMobileBreakpoint();
  const Component = isMobile ? Stack : Frame;
  return /*#__PURE__*/_jsx(CoreContainer, {
    as: as,
    children: /*#__PURE__*/_jsxs(Stack, {
      direction: ['column', null, 'row'],
      shouldWrapChildren: false,
      children: [header && /*#__PURE__*/_jsx(Component, {
        ratio: "1",
        sx: {
          width: ['size-full', null, 'size-quarter'],
          paddingY: [null, null, 'spacing-sm'],
          maxWidth: [null, null, 'size-19'],
          height: 'min-content'
        },
        children: /*#__PURE__*/_jsxs(Stack, {
          shouldWrapChildren: false,
          sx: {
            alignItems: ['center', null, 'flex-start !important'],
            textAlign: ['center', null, 'left'],
            paddingRight: [null, null, 'spacing-xl'],
            overflow: 'visible !important'
          },
          children: [/*#__PURE__*/_jsx(H3, {
            children: header.title
          }), header.shortDescription && /*#__PURE__*/_jsx(Text, {
            color: "quartz",
            children: header.shortDescription
          }), header.callToAction && /*#__PURE__*/_jsx(Link, {
            hasUnderline: true,
            href: header.callToAction.url,
            sx: {
              display: ['none', null, 'inherit']
            },
            children: header.callToAction.label
          })]
        })
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          paddingY: ['spacing-sm', null, null],
          width: ['size-full', null, header ? '75%' : 'size-full']
        },
        children: /*#__PURE__*/_jsx(InlineDeckReel, {
          items: items
        })
      }), (header === null || header === void 0 ? void 0 : header.callToAction) && /*#__PURE__*/_jsx(Link, {
        hasUnderline: true,
        href: header.callToAction.url,
        sx: {
          display: ['block', null, 'none'],
          textAlign: 'center'
        },
        children: header.callToAction.label
      })]
    })
  });
}